import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import {
  Icon,
  IconColor,
  IconSize,
} from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { MiniTitle } from '@delmonicos/shared-design-system-react/src/components/typography/mini-title/mini-title';
import {
  Text,
  TextColor,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { useTranslation } from 'react-i18next';

import { useEmspBoChargingSessionContext } from '../../emsp-bo-charging-session.context';

export const SessionTokenCardComponent = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const chargingSession = useEmspBoChargingSessionContext();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Card flex={1}>
      <Stack direction="column" gap={GapEnum.L}>
        <Stack
          gap={GapEnum.M}
          justifyContent="space-between"
          alignItems="center">
          <AccentTitle
            icon="credit-card-01"
            text={t('delmonicos-shared-sdk.outputs-charging-session.token-uid')}
            as={HeadingEnum.H2}
            variant={AccentVariantEnum.Secondary}
          />
          <Text>{chargingSession.tokenUid ?? '-'}</Text>
        </Stack>
        <Stack alignItems="center" justifyContent="space-between">
          <Stack alignItems="center" gap={GapEnum.XS} flex={1}>
            <Icon
              color={IconColor.Secondary}
              iconSize={IconSize.Small}
              name="clipboard"
            />
            <MiniTitle color={TextColor.Secondary}>
              {t('delmonicos-shared-sdk.outputs-charging-session.contract-id')}
            </MiniTitle>
          </Stack>
          <Stack flex={1}>
            <Text>{chargingSession.contractId ?? '-'}</Text>
          </Stack>
        </Stack>
        <Stack alignItems="center" justifyContent="space-between">
          <Stack alignItems="center" gap={GapEnum.XS} flex={1}>
            <Icon
              color={IconColor.Secondary}
              iconSize={IconSize.Small}
              name="building-01"
            />
            <MiniTitle color={TextColor.Secondary}>
              {t('delmonicos-shared-sdk.outputs-charging-session.cpo-id')}
            </MiniTitle>
          </Stack>
          <Stack flex={1}>
            <Text>{chargingSession.cpoId ?? '-'}</Text>
          </Stack>
        </Stack>
      </Stack>
    </Card>
  );
};
